(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["motureo-otkaz"]) return;
  try {
    
  (function () {
    var KLUCZ = 'motureoOtkaz';
    var PL = document.documentElement.lang === 'pl';
    // Motureo (jezyk_ro): wersja rumuńska (lang „ro”)
    var RO = (document.documentElement.lang || '').toLowerCase().indexOf('ro') === 0;
    var POLA = [
      ['MotureoOtkaz-imie', PL ? 'Imię i nazwisko' : RO ? 'Nume și prenume' : 'Име и фамилия'],
      ['MotureoOtkaz-email', PL ? 'E-mail' : RO ? 'E-mail' : 'Имейл'],
      ['MotureoOtkaz-zamowienie', PL ? 'Numer zamówienia' : RO ? 'Numărul comenzii' : 'Номер на поръчката'],
      ['MotureoOtkaz-towary', PL ? 'Towary' : RO ? 'Bunuri' : 'Стоки'],
      ['MotureoOtkaz-data', PL ? 'Data otrzymania' : RO ? 'Data primirii' : 'Дата на получаване'],
    ];

    function wypelnij(lista, wiersze) {
      lista.textContent = '';
      wiersze.forEach(function (w) {
        if (!w[1]) return;
        var dt = document.createElement('dt');
        var dd = document.createElement('dd');
        dt.textContent = w[0];
        dd.textContent = w[1];
        lista.appendChild(dt);
        lista.appendChild(dd);
      });
      lista.hidden = false;
    }

    function wynik() {
      var panel = document.querySelector('[data-otkaz-wynik]');
      if (!panel) return;
      var zapis;
      try {
        zapis = JSON.parse(sessionStorage.getItem(KLUCZ) || 'null');
      } catch (e) {
        zapis = null;
      }
      if (!zapis) return;
      var czas = document.querySelector('[data-otkaz-czas]');
      if (czas) {
        czas.textContent = (PL ? 'Data i godzina wysłania: ' : RO ? 'Data și ora transmiterii: ' : 'Дата и час на изпращане: ') + zapis.czas;
        czas.hidden = false;
      }
      wypelnij(panel, zapis.wiersze);
      sessionStorage.removeItem(KLUCZ);
    }

    function formularz() {
      var form = document.getElementById('MotureoOtkazForm');
      if (!form) return;
      var krok1 = form.querySelector('[data-otkaz-krok="1"]');
      var krok2 = form.querySelector('[data-otkaz-krok="2"]');
      var dalej = form.querySelector('[data-otkaz-dalej]');
      var wstecz = form.querySelector('[data-otkaz-wstecz]');
      var przeglad = form.querySelector('[data-otkaz-przeglad]');
      var czasPole = form.querySelector('[data-otkaz-czas-pole]');
      if (!krok1 || !krok2 || !dalej) return;

      dalej.hidden = false;
      wstecz.hidden = false;
      krok2.hidden = true;

      function wiersze() {
        return POLA.map(function (p) {
          var el = document.getElementById(p[0]);
          return [p[1], el ? el.value.trim() : ''];
        });
      }

      dalej.addEventListener('click', function () {
        var wymagane = krok1.querySelectorAll('[required]');
        for (var i = 0; i < wymagane.length; i++) {
          if (!wymagane[i].reportValidity()) return;
        }
        wypelnij(przeglad, wiersze());
        krok1.hidden = true;
        krok2.hidden = false;
        krok2.querySelector('h2').setAttribute('tabindex', '-1');
        krok2.querySelector('h2').focus();
      });

      wstecz.addEventListener('click', function () {
        krok2.hidden = true;
        krok1.hidden = false;
        dalej.focus();
      });

      form.addEventListener('submit', function () {
        var czas = new Date().toLocaleString(RO ? 'ro-RO' : 'bg-BG');
        if (czasPole) czasPole.value = new Date().toISOString();
        try {
          sessionStorage.setItem(KLUCZ, JSON.stringify({ czas: czas, wiersze: wiersze() }));
        } catch (e) {
          /* tryb prywatny: podsumowanie po wysłaniu nie będzie pokazane */
        }
      });
    }

    function start() {
      formularz();
      wynik();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
